/**
 * The list of MoT API endpoints.
 */
export const ACCESS_GROUPS_ENDPOINT = '/v1/access-controls/access-groups'
export const ACCESS_POLICIES_ENDPOINT = '/v1/access-controls/access-policies'
export const ACCESS_POLICY_ENDPOINT = '/v1/access-controls/access-policies/{policyId}'
export const ACCESS_POLICY_DEVICES_ENDPOINT =
  '/v1/access-controls/access-policies/{policyId}/devices'
export const ACCOUNT_PROVISIONING_ENDPOINT = '/v1/accounts/provision'
export const DEVICE_ENDPOINT = '/v1/devices'
export const DEVICE_STATS_ENDPOINT = '/v1/devices/{id}/stats'
export const DEVICE_CONTAINERS_ENDPOINT = '/v1/devices/{id}/containers'
export const DEVICE_CONTAINERS_EXECID_ENDPOINT = '/v1/devices/{id}/containers/{containerId}/execId'
export const DEVICE_COMMAND_RELAY_ENDPOINT = '/v1/devices/relay/docker'
export const FEATURE_FLAGS_ENDPOINT = '/v1/feature-flags'
